<template>
  <div class="mt-0" style="display: flex; justify-content: space-between; align-items: center;">
    <v-icon color="primary">
      description
    </v-icon>
    <span class="pl-2 body-2 flex-grow-1 fs-exclude" style="width: 35%;">
      {{ name }}
    </span>
    <div class="pt-4 flex-grow-1" :style="`min-width: ${$vuetify.breakpoint.smAndUp ? 55 : 35}%;`">
      <v-progress-linear
        v-if="showUpload"
        :color="colour"
        :indeterminate="!uploaded"
        :value="uploaded ? 100 : 0"
        rounded
        height="6"
      />
      <p v-if="showUpload" :class="getStatusColour" class="ma-0" style="text-align: end; width: 100%; font-size: 12px; text-transform: capitalize;">
        {{ currentStatus }}
      </p>
    </div>
    <v-btn icon class="ml-2" @click="removeFiles()">
      <v-icon class="text--disabled">
        highlight_off
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    status: { type: String, required: true },
    id: { type: Number, default: 0 }
  },
  computed: {
    showUpload() {
      return this.status !== 'none'
    },
    currentStatus() {
      return this.status
    },
    colour() {
      switch (this.status) {
        case 'failed':
          return 'error'
        default:
          return 'tertiary'
      }
    },
    uploaded() {
      return ['processed', 'failed'].includes(this.status)
    },
    getStatusColour() {
      switch (this.status) {
        case 'uploading':
          return 'info--text'
        case 'pending':
          return 'info--text'
        case 'processing':
          return 'warning--text'
        case 'failed':
          return 'error--text'
        case 'processed':
          return 'success--text'
        default:
          return 'info--text'
      }
    }
  },
  methods: {
    removeFiles() {
      this.$emit('removeFiles', this.id)
    }
  }
}
</script>
